/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationBaseForFinOps extends models.DescriptorForResourceRecommendation {
    constructor() {
        super();
        this.setDiscriminator("RecommendationBaseForFinOps");
    }

    getFixupPrototypeFunction() { return RecommendationBaseForFinOps.fixupPrototype; }

    static newInstance(model: Partial<RecommendationBaseForFinOps>): RecommendationBaseForFinOps {
        let obj = Object.assign(new RecommendationBaseForFinOps(), model);
        RecommendationBaseForFinOps.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationBaseForFinOps>): RecommendationBaseForFinOps {
        if (!model) return null;
        return RecommendationBaseForFinOps.newInstance(<RecommendationBaseForFinOps> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationBaseForFinOps) {
        if (!obj) return;

        models.RecommendationBaseForFinOps.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationBaseForFinOps): boolean {
        if (models.DescriptorForResourceRecommendation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationBaseForFinOps.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.additional_sku_details) {
            models.RecommendationSkuDetailsBase.fixupPrototype(this.additional_sku_details);
        }
        if (this.recommendation_options) {
            for (let val of this.recommendation_options) {
                models.RecommendationOptionsBase.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique Identifier for the current Sku.
     */
    current_sku_id: string;

    additional_sku_details: models.RecommendationSkuDetailsBase;

    recommendation_options: Array<models.RecommendationOptionsBase>;

}
